import { render } from "./Filters.vue?vue&type=template&id=6afc7c7d&bindings={}"
import script from "./Filters.vue?vue&type=script&lang=ts"
export * from "./Filters.vue?vue&type=script&lang=ts"

import "./Filters.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script